// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VlZB","question":"styles_question__kgMlj","description":"styles_description__1gArE"};